// eslint-disable-next-line
import {injectable} from "inversify";
import { IApiResponse, IHttpService } from "../http-service";
import { TYPE, rootContainer } from "../container/root";

export interface ICustomerAddress {
	address1: string,
	address2: string,
	city: string,
	company: string,
	country: string,
	countryCodeV2:string;
	firstName:string;
	formatted: string[];
	id:number;
	lastName:string;
	phone:string;
	province:string;
	postalCode:string;
	zip:string;
}

export interface ICustomer {
	defaultAddress: ICustomerAddress;
	email: string;
	firstName: string | null;
	id: string;
	denormalized_id: string;
	lastName: string | null;
	legacyResourceId: string;
	phone: string;
	credits: number | null;
	customerURL: string;
}

export interface ICustomerRmasList {
    total_count: number;
    list: {id: string}[];
};

@injectable()
class CustomersService{
	private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);
	
	public async fetchCustomers(customersIds: string[]): Promise<ICustomer[]> {
		const res = await this.httpService.post<IApiResponse<ICustomer[]>>(`/rms-api/customers`, {ids:customersIds});
		return res.payload;
	}
	
	public async fetchCustomerRmaList(id: string): Promise<ICustomerRmasList> {
		const res = await this.httpService.get<IApiResponse<ICustomerRmasList>>(`/rms-api/customer-rmas-list/${id}`,);
		return res.payload;
	}	
}


export default CustomersService;
